<template>
    <div class="pro-price mb-10">
        <ul>
            <li><b>برند : </b><span class="bran"> {{ data_product.brand.title }} </span></li>
            <li><b>کد محصول :</b> <span>{{data_product.code_product}}</span></li>
            <li><b>وضعیت موجودی :</b> <span class="instock">موجود</span></li>

            <li><b>آخرین بروزرسانی قیمت :</b> <span>{{timeiran.value}}</span></li>
            <li v-if="data_product.dicount!='0'"><b> درصد تخفیف :</b> <span class="bran"><b>{{data_product.dicount}}%-</b></span></li>
            <li style="font-size:14px; color: #ad0000;">*قیمت ها لیست قیمت شرکت بوده و درصد تخفیف ها در فاکتور لحاظ می شود.</li>
        </ul>
    </div>
    <div class="col-lg-12">
        <div  v-show="isShowDiscount()"  class="dis">%{{data_product.dicount}}-</div>
    <div class="breadcrumb pro-price " style="background-color: #363f4d; border-radius: 40px; color: white;">
        <p><span v-if="inactive_price == '1'" >تماس بگیرید </span></p>
        <p  v-if="inactive_price == '0'" style="font-size: 14px !important; margin-right: 55px; position: relative;"><span>قیمت: </span><span  class="price" style="font-size: 14px; " >{{hosein}}</span><span> ریال </span></p>
        <div style="width: 50px">
        <p v-show="isShow"   v-if="inactive_price == '0'" style="font-size: 11px !important; color: #ffffffb8; position: absolute; right: 86px; top: 29px;"><span>قیمت کارخانه: </span><span  class="prev-price" style="font-size: 11px; color: #ffffffb8;  text-decoration-line: line-through;" >{{price}}</span></p>
        </div>
        </div>
        </div>
     <span style="font-size:14px; color: #ad0000;">*جهت مشاهده قیمت, سایز محصول را انتخاب نمایید.</span>


       <div>
        <label class="control-label">سایز:</label>
        <select @change="move($event)"  required  name="size">
            <option   value=""> یک گزینه انتخاب کنید</option>
            <option v-if="inactive_price != '1'" v-for="size in data_product.sizes"  :value="size.price">{{size.title_size}}</option>
        </select>
         <br/><br/>
        <label class="control-label">ولتاژ:</label>
        <select  required  name="vol">
            <option value=""> یک گزینه انتخاب کنید</option>
            <option v-if="inactive_price != '1'" v-for="size in data_product.vol" :value="size.title_vol">{{size.title_vol}}</option>
        </select>
           <br/><br/>
        <label class="control-label">نوع موتور:</label>
        <select required name="motor">
            <option value=""> یک گزینه انتخاب کنید</option>
            <option v-if="inactive_price != '1'"  v-for="size in data_product.rpm" :value="size.title_rpm">{{size.title_rpm}}</option>
        </select>
       </div>
</template>

<script>
    import {reactive,ref} from "vue";
    import axios from "axios";

    export default {
        name: "ShowDropdon",
        props: ['product','inactive'],
        setup(props) {
            const data_product = reactive(props.product);
            const inactive_price = ref(props.inactive);
            const price = ref(data_product.price);
            const hosein = ref(data_product.price);
            const price_discount = ref(data_product.price);
            const timeiran = reactive([]);
            const isShow = ref(false);
            //const isShowDiscount = ref(true);
            const getTime = async() => {
                    try {
                        await axios.get('/api/time')
                            .then(res => {
                                timeiran.value = res.data;
                            })
                    }catch (e) {
                    this.errors.push(e)
                }
            };
            getTime();
            const isShowDiscount=() =>{

                if(data_product.dicount=='0') {
                    if (inactive_price.value == '1') {

                        return false;
                    }
                    if (inactive_price.value != '0') {

                        return false;
                    }
                }
                if(data_product.dicount!='0') {
                    if (inactive_price.value == '1') {

                        return false;
                    }
                    if (inactive_price.value != '1') {

                        return true;
                    }
                }

            }
            const move = (event) =>
            {
             //   console.log(event.target.value);
                if(event.target.value !='' ){
                    if (data_product.dicount==0){
                        isShow.value=false;
                        isShowDiscount.value=false;
                    }else {
                        isShow.value=true;
                    }

                   // str.replace('delete-','')
                    const a=event.target.value.replace(',','');
                    const b=a.replace(',','');
                    const price_discount=(b-((b / 100) * data_product.dicount)).toLocaleString();

                    return hosein.value=price_discount,price.value=event.target.value;
                }else
                {
                    if (data_product.dicount==0){
                        isShowDiscount.value=false;
                    }
                    isShow.value=false;
                    return hosein.value=data_product.price;
                }
            };

            return{
                data_product,
                timeiran,
                inactive_price,
                move,
                price,
                isShow,
                hosein,
                isShowDiscount,



            }
        },
    }

</script>

<style scoped>
.dis{
    width: 72px;
    border-radius: 100px;
    background: #dc3545;
    color: #ffffff;
    position: absolute;
    right: 5px;
    bottom: 0px;
    height: 100%;
    text-align: center;
    padding-top: 14px;
    BORDER: 2px #dc3545 solid;
    }

</style>
